import PostApi from '@/postApi';
export default {
	namespaced: true,
	state: {
	},
	actions: {
		async postQuest({
			commit
		},param) {
			const postQuest = await PostApi.postQuest(param);
			console.log('postQuest',commit);
			return postQuest;
		},
	},
	mutations: {
		
	},
}
